module.exports = __webpack_public_path__ + "img/times-solid.504c6cd9.svg";